import { getCheckoutConfig } from "../../core/models/checkout-config.model";
import { EnvModel, getEnvModel } from "../../core/models/env.model";
import { getGlobalConfig } from "../../core/models/global-config.model";
import { UiStringModel } from "../../core/models/ui-string.model";
import DataService from "../../core/services/data.service";
import { ResendConfirmationComponent } from "../../shared/components/resend-confirmation.component";

let confirmationInstance: ConfirmationViewModel;

export class ConfirmationViewModel {
    private dataService: DataService;

    private isShowCarousel = ko.observable(false);

    public uiStrings = ko.observable({} as UiStringModel);
    public accountId = ko.observable(0);

    public $env: EnvModel;
    public $uiStrings: UiStringModel;

    public recaptchaToken: string | null= null;
    private emailModal = document.getElementById('email-booking-modal');

    constructor() {
        confirmationInstance = this;

        this.$env = getEnvModel();
        this.dataService = new DataService(this.$env);
        const config = getGlobalConfig();
        this.$uiStrings = config.uiStrings;
        this.uiStrings(config.uiStrings);

        var gRecaptchaUrl = `https://www.google.com/recaptcha/api.js?render=${config.config.googleReCaptchaSiteKey}&size=invisible`;
        if ($('head script[src="' + gRecaptchaUrl + '"]').length == 0) {
            var head = document.getElementsByTagName('head')[0];
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = gRecaptchaUrl;
            script.async = true;
            script.defer = true;
            head.appendChild(script);
        }

        this.widgetScrollToTop();
        this.InitBindings();
        this.initWalletButtons();

        const checkout = getCheckoutConfig()!;

        this.isShowCarousel(checkout.showCarousel);

        this.accountId(checkout.accountId);
    }
    private InitBindings() {
        const localScope = this;
        $('.contact-eo-btn').click(function() {
            var evName = $(this).data('eventname');
            var eid = $(this).data('eid');
            var contactName = $(this).data('contactname');
            var contactNumber = $(this).data('contactnumber');

            $('#modal-event-name').text(evName);
            $('#event-name-hidden').val(evName);

            $('.eo-contact-container').hide();
            $('#eo-contact-name-container').hide();
            $('#eo-contact-number-container').hide();

            var showContactDetails = contactName && contactName.length > 0 && contactNumber && contactNumber.toString().length > 0;
            if (showContactDetails) {
                $('#eo-contact-name-container').show();
                $('#eo-contact-name').text(contactName);
                $('#eo-contact-number-container').show();
                $('#eo-contact-number').text(contactNumber.toString());
                $('.eo-contact-container').show();
            }

            $('#event-id-hidden').val(eid);

            $('.event-terms-link').attr('href', confirmationInstance.$env.eventSitePath + '/terms/' + eid.toString());

            $('#contact-email').val('');
            $('#contact-name').val('');
            $('#contact-phone-number').val('');
            $('#contact-message').val('');
            $('.form-container').show();
            $('.form-control').removeClass('has-validated');
            $('.form-control').removeClass('is-invalid');

            $('.form-submit-success-container').hide();
            $('.form-submit-error-container').hide();

            ($('#contact-eo-modal') as any)
                .modal({
                    keyboard: false,
                    show: true
                });
        });

        $('.contact-eo-submit')
            .click(() => {
                var contactModel = {
                    EventId: parseInt($('#event-id-hidden').val().toString()),
                    ContactUsGuid: $('#contact-guid').val(),
                    ContactName: $('#contact-name').val(),
                    ContactEmail: $('#contact-email').val(),
                    ContactPhone: $('#contact-phone-number').val(),
                    ContactMessage: $('#contact-message').val(),
                    BookingId: $('#booking-url-id-hidden').val(),
                    RecaptchaToken: ''
                };
                const contactEoButton = (document.getElementById('contact-eo-submit') as HTMLButtonElement);
                let siteKey = contactEoButton.getAttribute('data-sitekey')?.toString() ?? '';

                this.ShowPageSpinner();
                grecaptcha.ready(() => {
                    grecaptcha.execute(siteKey, { action: 'submit' }).then((token) => {
                        contactModel.RecaptchaToken = token;
                        this.dataService.ContactEO(contactModel)
                        .then((res: any) => {
                                this.ContactEOSuccessCallback();
                            },
                            (err: any) => {
                                if (err.responseJSON.ContactEoRateLimitReached !== undefined) {
                                    this.ContactEOErrorCallback(err.responseJSON.ContactEoRateLimitReached[0]);
                                } else if (err.responseJSON.ContactEoForbiddenKeywordFound !== undefined) {
                                    this.ContactEOErrorCallback(err.responseJSON.ContactEoForbiddenKeywordFound[0]);
                                } else {
                                    this.ContactEOErrorCallback();
                                }
                            })
                        .catch((err: any) => {
                            this.ContactEOErrorCallback()
                        })
                    });
                });
            });

        $('#contact-email').blur((ev: any) => {
            this.ValidateField(ev.currentTarget, 'Email');
            this.DisableEnableSendToEoBtn();
        });
        $('#contact-email').keyup((ev) => {
            this.ValidateField(ev.currentTarget, 'Email', true);
            this.DisableEnableSendToEoBtn();
        });

        $('#contact-name').blur((ev: any) => {
            this.ValidateField(ev.currentTarget, 'Your name');
            this.DisableEnableSendToEoBtn();
        });
        $('#contact-name').keyup((ev: any) => {
            this.ValidateField(ev.currentTarget, 'Your name', true);
            this.DisableEnableSendToEoBtn();
        });

        $('#contact-phone-number').blur((ev: any) => {
            this.ValidateField(ev.currentTarget, 'Your phone number');
            this.DisableEnableSendToEoBtn();
        });
        $('#contact-phone-number').keyup((ev: any) => {
            this.ValidateField(ev.currentTarget, 'Your phone number', true);
            this.DisableEnableSendToEoBtn();
        });

        $('#contact-message').blur((ev: any) => {
            this.ValidateField(ev.currentTarget, 'Message');
            this.DisableEnableSendToEoBtn();
        });

        $('#contact-message').keyup((ev: any) => {
            this.ValidateField(ev.currentTarget, 'Message', true);
            this.DisableEnableSendToEoBtn();
        });

        const resendConfirmationComponent = new ResendConfirmationComponent();
        document.querySelector('#resend-email-btn').addEventListener('click', resendConfirmationComponent.onSendConfirmationLinkClick);
        this.emailModal.addEventListener('click', resendConfirmationComponent.onModalClick);
        document.querySelector('#email-booking-modal [data-resend-url]').addEventListener('click', resendConfirmationComponent.onResendClick);
    }

    private ValidateField(target: any, label: string, shouldCheck?: boolean) {
        var $target = $(target);
        if (shouldCheck && !$target.hasClass('has-validated')) {
            return;
        }

        $target.addClass('has-validated');
        var validity = target.validity;
        if (!validity.valid) {
            var validationMessage = '';

            if (validity.valueMissing) {
                validationMessage = label + ' is required';
            } else if (validity.typeMismatch || validity.tooLong || validity.patternMismatch) {
                validationMessage = label + ' is invalid';
            }

            $target.addClass('is-invalid');
            $target.parent().children('.invalid-feedback').text(validationMessage);
        } else {
            $target.removeClass('is-invalid');
        }

    }

    private DisableEnableSendToEoBtn() {
        if (($('#contact-email')[0] as any).validity.valid
            && ($('#contact-name')[0] as any).validity.valid
            && ($('#contact-phone-number')[0] as any).validity.valid
            && ($('#contact-message')[0] as any).validity.valid > 0) {
            $('.contact-eo-submit').removeAttr('disabled');
        } else {
            $('.contact-eo-submit').attr('disabled', 'disabled');
        }
    }

    private ContactEOSuccessCallback() {
        $('.form-container').hide();
        $('.form-submit-success-container').show();
        this.HidePageSpinner();
    }

    private ContactEOErrorCallback(errorMessage?: string) {
        $('.form-container').hide();
        if (errorMessage !== undefined) {
            document.querySelector('.form-submit-error-container p')!.textContent = errorMessage;
        }

        $('.form-submit-error-container').show();
        this.HidePageSpinner();
    }

    private ShowPageSpinner() {
        $('.page-spinner').addClass('d-flex');
    }

    private HidePageSpinner() {
        $('.page-spinner').removeClass('d-flex');
    }

    private widgetScrollToTop() {
        if ('parentIFrame' in window) {
            (window as any).parentIFrame.sendMessage('TBWidgetScrollToTopInvoke');
        }
    }

    private initWalletButtons() {
        var appleWalletbuttons = document.querySelectorAll('#apple-wallet');
        for (var i = 0; i < appleWalletbuttons.length; i++) {
            appleWalletbuttons[i].addEventListener('click', function (e) {
                if ((window as any).global.config.isMatomoTrackingEnabled) {
                    var accountId = $(this).attr('data-aid');
                    const _paq = (window as any)._paq = (window as any)._paq || [];
                    _paq.push(['trackEvent', 'add-to-wallet', 'apple-wallet-booking-confirmation-page', `Apple Wallet - Booking confirmation page AccountId: ${accountId}`, 1]);
                }
    
                var bookingId = $(this).attr('data-booking-id');
                location.href= (window as any).global.uiStrings.eventSitePath + "/wallet/apple-pass?bookingId=" + bookingId;
            });
        }

        var googleWalletbuttons = document.querySelectorAll('#google-wallet');
        for (var i = 0; i < googleWalletbuttons.length; i++) {
            googleWalletbuttons[i].addEventListener('click', function (e) {
                if ((window as any).global.config.isMatomoTrackingEnabled) {
                    var accountId = $(this).attr('data-aid');
                    const _paq = (window as any)._paq = (window as any)._paq || [];
                    _paq.push(['trackEvent', 'add-to-wallet', 'google-wallet-booking-confirmation-page', `Google Wallet - Booking confirmation page AccountId: ${accountId}`, 1]);
                }
    
                var bookingId = $(this).attr('data-booking-id');
                var urlParams = new URLSearchParams(window.location.search);
                if (urlParams.has('widget') && urlParams.get('widget') == "true") {
                    window.open((window as any).global.uiStrings.eventSitePath + "/wallet/google-wallet-link?bookingId=" + bookingId, "_blank");
                } else {
                    location.href = (window as any).global.uiStrings.eventSitePath + "/wallet/google-wallet-link?bookingId=" + bookingId;
                }
            });
        }
    }
}